<template>
    <CalendarCell
        :class="cn('border-none p-0 text-center text-content-sm focus-within:relative focus-within:z-20', props.class)"
        v-bind="forwardedProps"
    >
        <slot />
    </CalendarCell>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { CalendarCellProps } from 'reka-ui';
import { CalendarCell, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<CalendarCellProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
